import React from "react";
import "../ourservice/Style.css";
import Footerlogo from "../../assets/img/footerlogo.svg";
import Heder from "../Header";
import Marquee from "react-fast-marquee";
import Menubg from "../../assets/img/Menu button.webp";
import Margueeimage1 from "../../assets/img/margueeimage1.webp";
import Margueeimage2 from "../../assets/img/margueeimage2.webp";
import Margueeimage3 from "../../assets/img/margueeimage3.webp";
import Margueeimage4 from "../../assets/img/margueeimage4.webp";
import Margueeimage5 from "../../assets/img/margueeimage5.webp";
import Margueeimage6 from "../../assets/img/margueeimage6.webp";
import Margueeimage7 from "../../assets/img/margueeimage7.webp";
import Margueeimage8 from "../../assets/img/margueeimage8.webp";
import Margueeimage9 from "../../assets/img/margueeimage9.webp";
import Margueeimage10 from "../../assets/img/margueeimage10.webp";
import Metasoftservice1 from "../../assets/img/metasoftservice1.webp";
import Metasoftservice2 from "../../assets/img/metasoftservice2.webp";
import Metasoftservice3 from "../../assets/img/metasoftservice3.webp";
import Metasoftservice4 from "../../assets/img/metasoftservice4.webp";
import Model from "../model/Model";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from "react-router-dom";
import Topbutton1 from "../../assets/img/top.svg";
function OurServices({ activeLink }) {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <div className="Bg_Ourservice relative">
        <div className="container">
          <Heder textColor="white" />
          <div>
            <p className="text-[#fff] flex items-center justify-center lg:mt-[200px] md:mt-[200px] mt-[200px] lg:text-[53px] md:text-[53px] text-[33px] font-medium ">
              Discover Our Story: Pioneering IT Solutions Since Day One.
            </p>
          </div>
          <div
            className="flex justify-end items-center "
            data-bs-toggle="modal"
            data-bs-target="#menu"
          >
            <img
              src={Menubg}
              alt="menubg"
              data-bs-toggle="modal"
              data-bs-target="#menu"
              className="fixed z-10 cursor-pointer bottom-0"
            ></img>
          </div>
        </div>
      </div>
      <div className="bg-service">
        <div className="container">
          <div className="mt-[100px] mb-[80px]">
            <p className="text-[48px] text-white text-center font-semibold h-[72px]">
              Our Services
            </p>
            <p className="text-[#D2CBCB] text-center m-auto text-[13px] font-normal h-[44px] lg:w-[999px] ">
              <span className="font-semibold">Metasoft IT Solutions</span> is a
              comprehensive technology service provider that offers a diverse
              range of solutions to meet the IT needs of businesses. with a
              focus on delivering high-quality services and products.{" "}
              <span className="font-semibold">Metasoft IT Solutions </span>
              excels in various areas to empower organizations and optimize
              their technology infrastructure.
            </p>
          </div>
          <div className="flex flex-wrap justify-between">
            <div className="relative lg:mt-0 md:mt-0 mt-[40px] border-l-4 border-white p-4 ">
              <svg
                width="140"
                height="120"
                viewBox="0 0 140 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 59.18C0 40.7267 3.30667 26.2733 9.92 15.82C16.64 5.36668 27.7333 0.140015 43.2 0.140015C58.6667 0.140015 69.7067 5.36668 76.32 15.82C83.04 26.2733 86.4 40.7267 86.4 59.18C86.4 77.74 83.04 92.3 76.32 102.86C69.7067 113.42 58.6667 118.7 43.2 118.7C27.7333 118.7 16.64 113.42 9.92 102.86C3.30667 92.3 0 77.74 0 59.18ZM64.32 59.18C64.32 51.2867 63.7867 44.6733 62.72 39.34C61.76 33.9 59.7333 29.4733 56.64 26.06C53.6533 22.6467 49.1733 20.94 43.2 20.94C37.2267 20.94 32.6933 22.6467 29.6 26.06C26.6133 29.4733 24.5867 33.9 23.52 39.34C22.56 44.6733 22.08 51.2867 22.08 59.18C22.08 67.2867 22.56 74.1133 23.52 79.66C24.48 85.1 26.5067 89.5267 29.6 92.94C32.6933 96.2467 37.2267 97.9 43.2 97.9C49.1733 97.9 53.7067 96.2467 56.8 92.94C59.8933 89.5267 61.92 85.1 62.88 79.66C63.84 74.1133 64.32 67.2867 64.32 59.18Z"
                  fill="white"
                />
                <path
                  d="M100.717 23.02V2.38001H139.278V119.02H116.237V23.02H100.717Z"
                  fill="white"
                />
              </svg>
              <p className="text-white text-[18px] text-start font-bold uppercase mt-5">
                IT Infrastructure & Services
              </p>
              <div className="mt-[80px]">
                <ul className="text-start text-white text-[24px] font-semibold capitalize">
                  <li
                    className="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#cloudservice_modal"
                  >
                    Cloud Services
                  </li>
                  {/* <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#sucessModal">
  Launch demo modal
</button> */}
                  <li
                   className="cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#wifisolution_modal"
                  >
                    WiFi Solutions
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#antivirus"  className="cursor-pointer">
                    Anti-virus Solutions
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#backup"  className="cursor-pointer">
                    Backup Solutions
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#email"  className="cursor-pointer">
                    Email Solutions
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#network"  className="cursor-pointer">
                    Networking
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#storage"  className="cursor-pointer">
                    Storage Solutions
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#server"  className="cursor-pointer">
                    Server Solutions
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-l-4 lg:mt-0 md:mt-0 mt-[40px] border-white p-4 relative">
              <svg
                width="182"
                height="120"
                viewBox="0 0 182 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 60C0 41.5467 3.30667 27.0934 9.92 16.64C16.64 6.18669 27.7333 0.960022 43.2 0.960022C58.6667 0.960022 69.7067 6.18669 76.32 16.64C83.04 27.0934 86.4 41.5467 86.4 60C86.4 78.56 83.04 93.12 76.32 103.68C69.7067 114.24 58.6667 119.52 43.2 119.52C27.7333 119.52 16.64 114.24 9.92 103.68C3.30667 93.12 0 78.56 0 60ZM64.32 60C64.32 52.1067 63.7867 45.4934 62.72 40.16C61.76 34.72 59.7333 30.2934 56.64 26.88C53.6533 23.4667 49.1733 21.76 43.2 21.76C37.2267 21.76 32.6933 23.4667 29.6 26.88C26.6133 30.2934 24.5867 34.72 23.52 40.16C22.56 45.4934 22.08 52.1067 22.08 60C22.08 68.1067 22.56 74.9334 23.52 80.48C24.48 85.92 26.5067 90.3467 29.6 93.76C32.6933 97.0667 37.2267 98.72 43.2 98.72C49.1733 98.72 53.7067 97.0667 56.8 93.76C59.8933 90.3467 61.92 85.92 62.88 80.48C63.84 74.9334 64.32 68.1067 64.32 60Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M110.478 94.56C120.717 86.0267 128.878 78.9334 134.958 73.28C141.038 67.52 146.104 61.5467 150.158 55.36C154.211 49.1734 156.238 43.0934 156.238 37.12C156.238 31.68 154.958 27.4134 152.398 24.32C149.838 21.2267 145.891 19.68 140.558 19.68C135.224 19.68 131.118 21.4934 128.238 25.12C125.358 28.64 123.864 33.4934 123.757 39.68H101.997C102.424 26.88 106.211 17.1734 113.357 10.56C120.611 3.94668 129.784 0.640015 140.878 0.640015C153.038 0.640015 162.371 3.89335 168.878 10.4C175.384 16.8 178.637 25.28 178.637 35.84C178.637 44.16 176.398 52.1067 171.918 59.68C167.438 67.2534 162.318 73.8667 156.558 79.52C150.798 85.0667 143.278 91.7867 133.998 99.68H181.198V118.24H102.157V101.6L110.478 94.56Z"
                  fill="#FAFAFA"
                />
              </svg>

              <p className="text-white text-[18px] text-start font-bold uppercase mt-5">
                Hardware Supply & Systems
              </p>
              <div className="lg:absolute md:absolute lg:mt-[0px] md:mt-[0px] mt-[80px] bottom-0">
                <ul className="text-start text-white text-[24px] font-semibold capitalize">
                  <li data-bs-toggle="modal" data-bs-target="#signage"  className="cursor-pointer">
                    Signage Display
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#interactive"  className="cursor-pointer">
                    Interactive Display
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#supply"  className="cursor-pointer">
                    All-in-One PC Supply
                  </li>
                  <li data-bs-toggle="modal" data-bs-target="#business"  className="cursor-pointer">
                    Business Laptop Supply
                  </li>
                </ul>
              </div>
            </div>
            <div className="border-l-4 lg:mt-0 md:mt-[40px] mt-[40px] border-white p-4 relative">
              <svg
                width="182"
                height="121"
                viewBox="0 0 182 121"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 59.52C0 41.0667 3.30667 26.6133 9.92 16.16C16.64 5.70667 27.7333 0.480003 43.2 0.480003C58.6667 0.480003 69.7067 5.70667 76.32 16.16C83.04 26.6133 86.4 41.0667 86.4 59.52C86.4 78.08 83.04 92.64 76.32 103.2C69.7067 113.76 58.6667 119.04 43.2 119.04C27.7333 119.04 16.64 113.76 9.92 103.2C3.30667 92.64 0 78.08 0 59.52ZM64.32 59.52C64.32 51.6267 63.7867 45.0133 62.72 39.68C61.76 34.24 59.7333 29.8133 56.64 26.4C53.6533 22.9867 49.1733 21.28 43.2 21.28C37.2267 21.28 32.6933 22.9867 29.6 26.4C26.6133 29.8133 24.5867 34.24 23.52 39.68C22.56 45.0133 22.08 51.6267 22.08 59.52C22.08 67.6267 22.56 74.4533 23.52 80C24.48 85.44 26.5067 89.8667 29.6 93.28C32.6933 96.5867 37.2267 98.24 43.2 98.24C49.1733 98.24 53.7067 96.5867 56.8 93.28C59.8933 89.8667 61.92 85.44 62.88 80C63.84 74.4533 64.32 67.6267 64.32 59.52Z"
                  fill="white"
                />
                <path
                  d="M103.757 33.44C104.291 22.7733 108.024 14.56 114.957 8.8C121.997 2.93334 131.224 0 142.638 0C150.424 0 157.091 1.38667 162.638 4.16C168.184 6.82667 172.344 10.5067 175.118 15.2C177.997 19.7867 179.438 25.0133 179.438 30.88C179.438 37.6 177.678 43.3067 174.158 48C170.744 52.5867 166.638 55.68 161.838 57.28V57.92C168.024 59.84 172.824 63.2533 176.238 68.16C179.758 73.0667 181.518 79.36 181.518 87.04C181.518 93.44 180.024 99.1467 177.038 104.16C174.158 109.173 169.837 113.12 164.077 116C158.424 118.773 151.598 120.16 143.598 120.16C131.544 120.16 121.731 117.12 114.157 111.04C106.584 104.96 102.584 96 102.157 84.16H123.918C124.131 89.3867 125.891 93.6 129.198 96.8C132.611 99.8933 137.251 101.44 143.118 101.44C148.558 101.44 152.717 99.9467 155.598 96.96C158.584 93.8667 160.077 89.92 160.077 85.12C160.077 78.72 158.051 74.1333 153.998 71.36C149.944 68.5867 143.651 67.2 135.118 67.2H130.478V48.8H135.118C150.264 48.8 157.838 43.7333 157.838 33.6C157.838 29.0133 156.451 25.44 153.678 22.88C151.011 20.32 147.117 19.04 141.997 19.04C136.984 19.04 133.091 20.4267 130.318 23.2C127.651 25.8667 126.104 29.28 125.677 33.44H103.757Z"
                  fill="white"
                />
              </svg>

              <p className="text-white text-[18px] text-start font-bold uppercase mt-5 w-[335px]">
                Security & Communication Solutions
              </p>
              <div className="lg:absolute lg:mt-[0px] md:mt-[80px] mt-[80px] bottom-0">
                <ul className="text-start text-white text-[24px] font-semibold capitalize">
                  <li
                    className="pabx cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#pabx"
                  >
                    PABX Solutions{" "}
                  </li>
                  <li
                    className="system cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#system"
                  >
                    Access Control System
                  </li>
                  <li
                    className="cctv cursor-pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#cctv"
                  >
                    CCTV Solutions
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-[100px]">
            <p className="text-white text-center text-[48px] font-semibold ">
              Other Services
            </p>
            <div className="flex flex-wrap justify-center gap-5 mt-5">
              <Link to="" target="_blank">
                <button className="btnothrservice">Digital Marketing</button>
              </Link>
              <Link to="https://metasoft.ae/" target="_blank">
                <button className="btnothrservice">Web Development</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-white lg:mt-[150px] md:mt-[100px] mt-[30px] pb-3">
          <div className="container">
            <div className="mt-[80px]">
              <p className="text-black text-[48px] font-semibold text-center">
                Trusted Authorized Dealers{" "}
              </p>
              <p className="text-black text-[13px] font-normal text-center mt-5">
                Metasoft IT Solutions proudly serves as an authorized partner of
                renowned technology giants including Dell, Lenovo, Microsoft,
                Adobe, and more. As a trusted partner, we offer access to the
                latest products and solutions from these industry leaders. Our
                expertise combined with our authorized partner status ensures
                that you receive genuine, high-quality hardware and software
                solutions to drive your business forward. With our strong
                partnerships and direct access to these industry-leading brands,
                we can offer competitive pricing on a wide range of hardware and
                software solutions
              </p>
            </div>
          </div>
          <div className="lg:mt-[170px] md:mt-[140px] mt-[60px]">
            <Marquee pauseOnHover speed={100}>
              <div className="image_wrapper">
                <img src={Margueeimage1} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage2} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage3} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage4} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage5} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage1} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage2} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage3} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage4} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage5} alt="marqueimg1"></img>
              </div>
            </Marquee>
          </div>
          <div className="lg:mt-[90px] md:mt-[60px] mt-[40px] lg:mb-[180px] md:mb-[140px] mb-[100px]">
            <Marquee pauseOnHover direction="right" speed={100}>
              <div className="image_wrapper">
                <img src={Margueeimage6} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage7} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage8} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage9} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage10} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage6} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage7} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage8} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage9} alt="marqueimg1"></img>
              </div>
              <div className="image_wrapper">
                <img src={Margueeimage10} alt="marqueimg1"></img>
              </div>
            </Marquee>
          </div>
        </div>
        <div className="flex justify-center">
          <Link to="/mastery">
            {" "}
            <div className="imageservices cursor-pointer">
              <img src={Metasoftservice1} alt="Metasoftservice1" />
              <div className="image-overlay">
                {/* <img src="" alt='Top Image 1' /> */}
                <p className="lg:text-[52px] md:text:[42px] text-[18px] text-[#D4D4D4] text-center rotate-90 font-bold">
                  MetasoftMetaverseMastery
                </p>
              </div>
            </div>
          </Link>
          <Link to="/automation">
            {" "}
            <div className="imageservices cursor-pointer">
              <img src={Metasoftservice2} alt="Metasoftservice2" />
              <div className="image-overlay">
                {/* <img src="" alt='Top Image 2' /> */}
                <p className="lg:text-[52px] md:text:[42px] text-[18px] text-[#D4D4D4] text-center rotate-90 font-bold">
                  MetasoftAutomation
                </p>
              </div>
            </div>
          </Link>
          <Link to="/iot">
            {" "}
            <div className="imageservices">
              <img src={Metasoftservice3} alt="Metasoftservice3" />
              <div className="image-overlay">
                {/* <img src="" alt='Top Image 2' /> */}
                <p className="lg:text-[52px] md:text:[42px] text-[18px] text-[#D4D4D4] text-center rotate-90 font-bold">
                  MetasoftIOT
                </p>
              </div>
            </div>
          </Link>
          <Link to="/ai">
            <div className="imageservices">
              <img src={Metasoftservice4} alt="Metasoftservice4" />
              <div className="image-overlay">
                {/* <img src="" alt='Top Image 2' /> */}
                <p className="lg:text-[52px] md:text:[42px] text-[18px] text-[#D4D4D4] text-center rotate-90 font-bold">
                  MetasoftAI
                </p>
              </div>
            </div>
          </Link>
        </div>

        {/* <div className='flex'>
    <div className='relative'><img src={Metasoftservice1} alt='Metasoftservice1'></img>

        <p className='text-[65px] text-[#D4D4D4] text-start font-bold rotate-90 absolute left-0 top-[50%]'>MetasoftMetaverseMastery</p>

    </div>
    <div><img src={Metasoftservice2} alt='Metasoftservice2'></img>
    <p className='text-[65px] text-[#D4D4D4] text-start font-bold rotate-90 absolute left-0 top-[50%]'>MetasoftMetaverseMastery</p>
</div>
    <div><img src={Metasoftservice3} alt='Metasoftservice3'></img>
    <p className='text-[65px] text-[#D4D4D4] text-start font-bold rotate-90 absolute left-0 top-[50%]'>MetasoftMetaverseMastery</p>
</div>
    <div><img src={Metasoftservice4} alt='Metasoftservice4'></img>
    <p className='text-[65px] text-[#D4D4D4] text-start font-bold rotate-90 absolute left-0 top-[50%]'>MetasoftMetaverseMastery</p>

    </div>
</div> */}
        <div>
          <div className="container lg:mt-[100px]">
            <div className="text-[#fff] text-center mt-[160px] m-auto text-[48px] font-semibold capitalize lg:w-[655px] md:w-[655px]">
              <p>We Would Love To Hear From You...</p>
            </div>
            <div className="flex justify-center mt-[60px]">
              <Link to="/contact">
                {" "}
                <button className="btnfooter">Get In Touch </button>
              </Link>
            </div>
            <div className="border-t border-solid border-[#5B5B5B] mt-[200px]">
              <div className="flex justify-between items-center lg:mt-[30px] md:mt-0 mt-[30px]">
                <img src={Footerlogo} alt="footerlogo"></img>
                <div className="flex justify-end items-end ">
                  {/* <Link to="" target="_blank" className="chatWithUs">
            <img src={Bannerlogo} alt="logobanner"></img>
          </Link> */}

                  <button className="myBtn1">
                    <Link onClick={scrollToTop}>
                      <img alt="" src={Topbutton1} />
                    </Link>
                  </button>
                </div>
              </div>
              <div className="lg:flex justify-between  mt-[40px]">
                <div className="flex lg:gap-[50px] md:gap-[50px] gap-[30px] lg:justify-between md:justify-center hustify-between">
                  <div className="border-solid border-[#D9D9D9] border-r-2 lg:pr-3 md:pr-3 pr-3 lg:h-[120px]">
                    <h5 className="text-[#FFF] text-[14px] font-semibold text-start ">
                      Head Office
                    </h5>
                    <p className="text-[#FFF] font-extralight mt-3 text-[14px] w-[165px] text-start leading-6">
                      {" "}
                      Office No. 216A, PO Box No. 90071, Ittihad Square, Al
                      Ittihad Road , Dubai, UAE
                    </p>
                  </div>
                  <div className="">
                    <h5 className="text-[#FFF] text-[14px] font-semibold text-start">
                      Branch
                    </h5>
                    <p className="text-[#FFF] font-extralight mt-3 text-[14px] w-[165px] text-start leading-6">
                      {" "}
                      Door No.13-I-T/14, 3rd floor - Excel Mall, K.S.Rao Road,
                      Hampankatta, Mangaluru, Karnataka 575001
                    </p>
                  </div>
                </div>
                <div className="flex justify-between lg:justify-between md:justify-center lg:gap-[50px] md:gap-[120px] gap-[20px] lg:mt-0 md:mt-5 mt-[30px]">
                  <div className="">
                    <h5 className="text-[#FFF] text-[14px] font-semibold text-start">
                      Important Links
                    </h5>
                    <Link to="/ourservices" className="no-underline">
                      {" "}
                      <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                        Our Service
                      </p>
                    </Link>
                    <Link to="/about" className="no-underline">
                      {" "}
                      <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                        About Us
                      </p>
                    </Link>
                    <Link to="contact" className="no-underline">
                      <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                        Contact
                      </p>
                    </Link>
                    <Link to="/ourbrands" className="no-underline">
                      {" "}
                      <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                        Our Brands
                      </p>
                    </Link>
                  </div>
                  <div className="">
                    <h5 className="text-[#FFF] text-[14px] font-semibold text-start">
                      Mail{" "}
                    </h5>
                    <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                      Admin@metasoft.ae
                    </p>

                    <h5 className="text-[#FFF] text-[14px] font-semibold mt-2 text-start">
                      Call{" "}
                    </h5>
                    <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                      Tel: +971 43 99 1704
                    </p>
                    <p className="text-[#FFF] font-extralight mt-3 text-[14px]  text-start">
                      Mob: +971 56 1163 704
                    </p>
                  </div>
                </div>
                <div className="lg:mt-0 md:mt-0 mt-[30px]">
                  <h5 className="text-[#FFF] text-[14px] font-semibold text-center ">
                    Follow Us On
                  </h5>
                  <div className="flex justify-between gap-4 items-center pt-3">
                    <Link
                      to="https://www.facebook.com/metasoftitsolutions"
                      className="no-underline"
                      target="_blank"
                    >
                      {" "}
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M30.25 16.5C30.25 8.91 24.09 2.75 16.5 2.75C8.91 2.75 2.75 8.91 2.75 16.5C2.75 23.155 7.48 28.6962 13.75 29.975V20.625H11V16.5H13.75V13.0625C13.75 10.4088 15.9088 8.25 18.5625 8.25H22V12.375H19.25C18.4937 12.375 17.875 12.9937 17.875 13.75V16.5H22V20.625H17.875V30.1813C24.8188 29.4938 30.25 23.6362 30.25 16.5Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                    <Link
                      to="https://www.instagram.com/metasoft_it/"
                      className="no-underline"
                      target="_blank"
                    >
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.9135 2.75169C18.9169 2.74784 19.9203 2.75793 20.9234 2.78194L21.1901 2.79157C21.4981 2.80257 21.802 2.81632 22.1691 2.83282C23.6321 2.90157 24.6304 3.13257 25.5063 3.47219C26.4137 3.82144 27.1783 4.29444 27.9428 5.05894C28.6418 5.7459 29.1828 6.57687 29.5281 7.49407C29.8678 8.36994 30.0988 9.36957 30.1675 10.8326C30.184 11.1983 30.1978 11.5036 30.2087 11.8116L30.217 12.0783C30.2414 13.081 30.252 14.0839 30.2486 15.0868L30.25 16.1126V17.9138C30.2534 18.9172 30.2428 19.9206 30.2184 20.9237L30.2101 21.1904C30.1991 21.4984 30.1854 21.8023 30.1689 22.1694C30.1001 23.6324 29.8664 24.6307 29.5281 25.5066C29.1839 26.4247 28.6428 27.2564 27.9428 27.9431C27.2552 28.642 26.4238 29.183 25.5063 29.5284C24.6304 29.8681 23.6321 30.0991 22.1691 30.1678C21.802 30.1843 21.4981 30.1981 21.1901 30.2091L20.9234 30.2173C19.9203 30.2418 18.9169 30.2523 17.9135 30.2489L16.8877 30.2503H15.0879C14.0845 30.2537 13.0811 30.2432 12.078 30.2187L11.8112 30.2104C11.4848 30.1986 11.1585 30.1849 10.8322 30.1692C9.36925 30.1004 8.371 29.8667 7.49375 29.5284C6.57619 29.1838 5.74508 28.6427 5.05862 27.9431C4.35881 27.256 3.81731 26.4245 3.47188 25.5066C3.13225 24.6307 2.90125 23.6324 2.8325 22.1694C2.81719 21.8432 2.80344 21.5168 2.79125 21.1904L2.78438 20.9237C2.75902 19.9206 2.74757 18.9172 2.75 17.9138V15.0868C2.74616 14.0839 2.75625 13.081 2.78025 12.0783L2.78987 11.8116C2.80087 11.5036 2.81462 11.1983 2.83112 10.8326C2.89987 9.36819 3.13087 8.37132 3.4705 7.49407C3.81614 6.57642 4.3587 5.74568 5.06 5.06032C5.74598 4.3601 6.57657 3.8181 7.49375 3.47219C8.371 3.13257 9.36787 2.90157 10.8322 2.83282L11.8112 2.79157L12.078 2.78469C13.0806 2.75935 14.0836 2.7479 15.0865 2.75032L17.9135 2.75169ZM16.5 9.62669C15.5891 9.61381 14.6847 9.7821 13.8393 10.1218C12.994 10.4615 12.2246 10.9658 11.5759 11.6054C10.9272 12.245 10.4121 13.0072 10.0604 13.8476C9.70884 14.6881 9.52778 15.59 9.52778 16.501C9.52778 17.412 9.70884 18.314 10.0604 19.1544C10.4121 19.9948 10.9272 20.757 11.5759 21.3966C12.2246 22.0362 12.994 22.5405 13.8393 22.8802C14.6847 23.2199 15.5891 23.3882 16.5 23.3753C18.3234 23.3753 20.072 22.651 21.3614 21.3617C22.6507 20.0724 23.375 18.3237 23.375 16.5003C23.375 14.677 22.6507 12.9283 21.3614 11.639C20.072 10.3496 18.3234 9.62669 16.5 9.62669ZM16.5 12.3767C17.0479 12.3666 17.5924 12.4658 18.1016 12.6685C18.6108 12.8712 19.0745 13.1733 19.4656 13.5572C19.8567 13.9411 20.1674 14.3991 20.3795 14.9044C20.5916 15.4097 20.7009 15.9523 20.701 16.5003C20.7011 17.0483 20.592 17.5909 20.38 18.0963C20.1681 18.6017 19.8575 19.0598 19.4666 19.4438C19.0756 19.8279 18.612 20.1301 18.1029 20.333C17.5938 20.5359 17.0493 20.6352 16.5014 20.6253C15.4074 20.6253 14.3581 20.1907 13.5846 19.4171C12.811 18.6435 12.3764 17.5943 12.3764 16.5003C12.3764 15.4063 12.811 14.3571 13.5846 13.5835C14.3581 12.8099 15.4074 12.3753 16.5014 12.3753L16.5 12.3767ZM23.7188 7.56419C23.2752 7.58195 22.8557 7.77065 22.5481 8.09078C22.2405 8.41091 22.0687 8.83763 22.0687 9.28157C22.0687 9.72551 22.2405 10.1522 22.5481 10.4724C22.8557 10.7925 23.2752 10.9812 23.7188 10.9989C24.1746 10.9989 24.6118 10.8179 24.9341 10.4955C25.2564 10.1732 25.4375 9.73603 25.4375 9.28019C25.4375 8.82435 25.2564 8.38718 24.9341 8.06485C24.6118 7.74252 24.1746 7.56144 23.7188 7.56144V7.56419Z"
                          fill="white"
                        />
                      </svg>
                    </Link>

                    <svg
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.0319 3.09375H29.5804L19.6432 14.4513L31.3335 29.9062H22.1787L15.0095 20.5329L6.80625 29.9062H2.255L12.8837 17.7581L1.67062 3.09375H11.055L17.5354 11.6614L25.0291 3.09375H25.0319ZM23.4355 27.1838H25.9559L9.68687 5.67325H6.98225L23.4355 27.1838Z"
                        fill="white"
                      />
                    </svg>
                    <Link
                      to="https://www.linkedin.com/company/31008439/admin/feed/posts/"
                      className="no-underline"
                      target="_blank"
                    >
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M26.125 4.125C26.8543 4.125 27.5538 4.41473 28.0695 4.93046C28.5853 5.44618 28.875 6.14565 28.875 6.875V26.125C28.875 26.8543 28.5853 27.5538 28.0695 28.0695C27.5538 28.5853 26.8543 28.875 26.125 28.875H6.875C6.14565 28.875 5.44618 28.5853 4.93046 28.0695C4.41473 27.5538 4.125 26.8543 4.125 26.125V6.875C4.125 6.14565 4.41473 5.44618 4.93046 4.93046C5.44618 4.41473 6.14565 4.125 6.875 4.125H26.125ZM25.4375 25.4375V18.15C25.4375 16.9612 24.9652 15.821 24.1246 14.9804C23.284 14.1398 22.1438 13.6675 20.955 13.6675C19.7863 13.6675 18.425 14.3825 17.765 15.455V13.9288H13.9288V25.4375H17.765V18.6587C17.765 17.6 18.6175 16.7338 19.6763 16.7338C20.1868 16.7338 20.6764 16.9366 21.0374 17.2976C21.3984 17.6586 21.6012 18.1482 21.6012 18.6587V25.4375H25.4375ZM9.46 11.77C10.0727 11.77 10.6602 11.5266 11.0934 11.0934C11.5266 10.6602 11.77 10.0727 11.77 9.46C11.77 8.18125 10.7387 7.13625 9.46 7.13625C8.8437 7.13625 8.25265 7.38107 7.81686 7.81686C7.38107 8.25265 7.13625 8.8437 7.13625 9.46C7.13625 10.7387 8.18125 11.77 9.46 11.77ZM11.3713 25.4375V13.9288H7.5625V25.4375H11.3713Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="flex justify-between  mt-[10px] pb-[60px]">
                <p className="text-[#C6C6C6] text-[10px] font-medium">
                  {" "}
                  Copyright © 2024 metasoft. All Rights Reserved.{" "}
                </p>
                <div className="flex gap-5 items-centet">
                  <p className="text-[#C6C6C6] text-[10px] font-medium">
                    Terms of use | Privacy Environmental Policy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="cloudservice_modal modal fade bd-example-modal-lg"
        id="cloudservice_modal"
        tabindex="-1"
        aria-labelledby="cloudservice_Label"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  {" "}
                  Cloud Services{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  {" "}
                  Metasoft IT Solutions leverages the power of leading cloud
                  platforms, such as Microsoft Azure and Amazon Web Services
                  (AWS), to provide scalable and cost-effective cloud solutions
                  to businesses. They assist in cloud migration, architecture
                  design, deployment, and ongoing management of cloud
                  infrastructure. By leveraging the flexibility and scalability
                  of cloud services, businesses can optimize their IT resources,
                  improve agility, and access a wide range of cloud-based
                  applications and services
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="wifisolution_modal modal fade bd-example-modal-lg"
        id="wifisolution_modal"
        tabindex="-1"
        aria-labelledby="wifisolution_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Wifi solution{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  {" "}
                  Metasoft IT Solutions offers WiFi solutions designed to
                  deliver reliable and secure wireless connectivity within
                  business environments. They design and implement WiFi networks
                  that provide seamless coverage, high-speed connectivity, and
                  strong network security. These solutions enable businesses to
                  foster a connected and productive environment for employees
                  and visitors
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="antivirus modal fade bd-example-modal-lg"
        id="antivirus"
        tabindex="-1"
        aria-labelledby="antivirusLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Anti-Virus solution{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  with the increasing sophistication of cyber threats, Metasoft
                  IT Solutions provides robust anti-virus solutions to protect
                  businesses from malware, viruses, and other security risks.
                  They deploy cutting-edge security software and implement
                  proactive measures to detect and prevent cyber threats,
                  ensuring the integrity and confidentiality of business data
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="backup modal fade bd-example-modal-lg"
        id="backup"
        tabindex="-1"
        aria-labelledby="backupLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Backup solution{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  To ensure data integrity and business continuity, Metasoft IT
                  Solutions offers comprehensive backup solutions. They deploy
                  advanced backup strategies, combining on-site and off-site
                  backup methodologies, to safeguard critical data against
                  accidental loss, hardware failure, or cyber threats Metasoft
                  IT Solutions ensures that businesses can quickly recover their
                  data and resume operations in the event of a disruption
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="email modal fade bd-example-modal-lg"
        id="email"
        tabindex="-1"
        aria-labelledby="emailLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  email solution{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Understanding the importance of mobility and productivity in
                  today's business environment, Metasoft IT Solutions provides a
                  wide selection of high-performance laptops suitable for
                  professional use. These laptops are carefully selected to meet
                  the demands of modern workflows, combining power, durability,
                  and versatility to enhance work efficiency and enable seamless
                  collaboration
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="network modal fade bd-example-modal-lg"
        id="network"
        tabindex="-1"
        aria-labelledby="networLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Networking
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft IT Solutions offers networking services to ensure
                  businesses have reliable and secure connectivity. They design
                  and implement robust network architectures, including wired
                  and wireless networks, to facilitate efficient communication
                  and data transfer. By optimizing network performance and
                  implementing strong security measures, Metasoft IT Solutions
                  helps businesses maintain a stable and resilient network
                  infrastructure
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="storage modal fade bd-example-modal-lg"
        id="storage"
        tabindex="-1"
        aria-labelledby="storageLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Storage solution{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Recognising the growing need for efficient data storage and
                  management, Metasoft IT Solutions provides innovative storage
                  solutions tailored to the unique requirements of businesses.
                  These solutions encompass a range of technologies, including
                  network attached storage (NAS), storage area networks (SAN),
                  and cloud based storage, enabling businesses to store, access,
                  and protect their data effectively
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="server modal fade bd-example-modal-lg"
        id="server"
        tabindex="-1"
        aria-labelledby="serverLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  server solution{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  We take pride in serving a prestigious roster of premium
                  clients who have placed their trust in Metasoft IT Solutions.
                  These industry-leading organizations rely on our expertise in
                  IT infrastructure solutions, website development, digital
                  marketing and innovative technologies.
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="signage modal fade bd-example-modal-lg"
        id="signage"
        tabindex="-1"
        aria-labelledby="signageLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Signage Display{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft IT Solutions provides digital signage solutions for
                  businesses to enhance their visual communication and
                  advertising efforts. They design and deploy digital signage
                  displays that can be remotely managed and updated with dynamic
                  content. These displays are ideal for showcasing promotional
                  offers, delivering informational messages, and creating
                  engaging experiences in various environments, including retail
                  stores, corporate offices, and public spaces.
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="interactive modal fade bd-example-modal-lg"
        id="interactive"
        tabindex="-1"
        aria-labelledby="interactiveLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Interactive Display{" "}
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft IT Solutions offers interactive display solutions
                  that enable businesses to engage with their audience in a
                  dynamic and immersive manner. These displays incorporate
                  touch-screen technology and interactive capabilities, allowing
                  businesses to deliver interactive presentations, showcase
                  products, and create engaging user experiences. Interactive
                  displays are particularly useful in sectors such as education,
                  hospitality, and retail
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="supply modal fade bd-example-modal-lg"
        id="supply"
        tabindex="-1"
        aria-labelledby="supplyLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  ALL in one pc supply
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft IT Solutions offers all-in-one PCs that integrate the
                  functionality of a computer into single device, eliminating
                  clutter and maximizing space efficiency. These PCs are
                  equipped with powerful processors, ample storage, and
                  displays, making high-resolution them ideal for businesses
                  seeking streamlined workstations without compromising
                  performance or aesthetics
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="business modal fade bd-example-modal-lg"
        id="business"
        tabindex="-1"
        aria-labelledby="businessLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Business Laptop Supply
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Understanding the importance of mobility and productivity in
                  today's business environment, Metasoft IT Solutions provides a
                  wide selection of high-performance laptops suitable for
                  professional use. These laptops are carefully selected to meet
                  the demands of modern workflows, combining power, durability,
                  and versatility to enhance work efficiency and enable seamless
                  collaboration
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="pabx modal fade bd-example-modal-lg"
        id="pabx"
        tabindex="-1"
        aria-labelledby="pabxLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  PABX solutions
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft IT Solutions offers PABX (Private Automated Branch
                  Exchange) solutions, also known as telephone systems, to
                  facilitate efficient communication within businesses. These
                  solutions enable businesses to manage their phone lines,
                  internal extensions, call routing, and advanced call features.
                  PABX solutions enhance communication capabilities, streamline
                  call management, and support collaboration among employees
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="system modal fade bd-example-modal-lg"
        id="system"
        tabindex="-1"
        aria-labelledby="systemabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  Access control System
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft IT Solutions provides access control systems that
                  enable businesses to manage and monitor access to their
                  premises. These systems employ combination of security
                  technologies such as biometric authentication, access cards,
                  and door locks to regulate entry and enhance physical
                  security. By implementing access control solutions, businesses
                  can restrict unauthorised access, track entry events, and
                  improve overall security
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="cctv modal fade bd-example-modal-lg"
        id="cctv"
        tabindex="-1"
        aria-labelledby="cctvLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div className="justify-end flex items-center">
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" className="text-white text-[50px]">
                    &times;
                  </span>
                </button>
              </div>
              <div className="">
                <p className="text-white cap text-[48px] font-semibold mt-[100px] capitalization">
                  CCTV Solutions
                </p>
                <p className="text-white text-center text-[15px] font-normal w-[805px] m-auto">
                  Metasoft I Solutions specialises in comprehensive CCTV
                  solutions for businesses. They design and implement
                  surveillance systems that utilise high-quality cameras, video
                  recorders, and monitoring software to enhance security and
                  protect valuable assets. These solutions enable businesses to
                  monitor and record activities within their premises, providing
                  a deterrent to potential threats and assisting with incident
                  investigations
                </p>
              </div>
              <div className="flex justify-center mt-[60px]">
                <button className="btnmodal">Get In Touch </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Model activeLink={activeLink} />
    </>
  );
}

export default OurServices;
